import React from 'react'
import { ZakupLicencjiPlatnoscStyle } from '../../styles/ZakupLicencjiStyle'
import Button from '@material-ui/core/Button'
import { formatAmount } from '../../lib/formatAmountHandler'
import { koniecWaznosciLicencji } from '../../lib/consts'

export default function ZakupLicencjiPlatnosc({ data, onPay }) {
  return (
    <ZakupLicencjiPlatnoscStyle>
      <div className="medium-headline-5">Podsumowanie zamówienia</div>
      <div className="paymentSummary">
        <div className="disabled-caption text-end">KUPUJĄCY:</div>
        <div className="text-start">
          <div className="high-emphasis-body-2">{data.nazwaFirmy}</div>
          <div className="medium-emphasis-body-2">
            {data.ulica} {data.nrDomu}{' '}
            {data.nrLokalu ? ' / ' + data.nrLokalu : ''}
          </div>
          <div className="medium-emphasis-body-2">
            {data.kodPocztowy} {data.poczta ? data.poczta : data.miejscowosc}
          </div>
          <div className="medium-emphasis-body-2">NIP: {data.NIP}</div>
        </div>
        <div className="disabled-caption text-end">WARIANT LICENCJI:</div>
        <div className="high-emphasis-body-2 text-start">
          {data.wariantLicencji.wariantText}
        </div>
        <div className="disabled-caption text-end">LICENCJA WAŻNA DO:</div>
        <div className="high-emphasis-body-2 text-start">
          {koniecWaznosciLicencji}
        </div>
        <div className="disabled-caption text-end">KWOTA DO ZAPŁATY:</div>{' '}
        <div className="high-emphasis-body-2 text-start">
          {formatAmount(data.wariantLicencji.cenaBrutto, 2)} (z VAT)
        </div>
      </div>
      <div className="medium-headline-5">Zapłać wygodnie on-line</div>
      <div className="paymentText">
        <div className="disabled-subtitle-2">
          Za chwilę przeniesiemy Cię na stronę serwisu TPAY.COM, gdzie w
          bezpieczny i wygodny sposób dokonasz płatności.
        </div>
        <div className="medium-emphasis-subtitle-2">
          Prosimy, nie zmieniaj tytułu płatności ani kwoty, gdyż może to
          skutkować odrzuceniem lub opóźnieniem transakcji.
        </div>
      </div>
      <div className="disabled-subtitle-2 paymentText">
        Po zakończeniu transakcji przeniesiemy Cię na stronę startową naszego
        programu. Dołożymy wszelkich starań, <br /> by po ponownym zalogowaniu
        do programu Twoja licencja była już aktywna. Gdyby tak się nie stało,
        <br />
        po prostu odczekaj chwilę i spróbuj ponownie - czasem weryfikacja
        płatności musi trochę potrwać.
      </div>
      <div className="disabled-subtitle-2 paymentText">
        Faktura za zakup programu zostanie przesłana drogą emailową na podany adres.
      </div>
      <Button
        className="paymentBtn"
        variant="contained"
        color="primary"
        onClick={() => onPay()}
      >
        ZAPŁAĆ
      </Button>
    </ZakupLicencjiPlatnoscStyle>
  )
}
